var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Label-staff" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.createHandle }
            },
            [_vm._v("新建欢迎语")]
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: "calc(100vh - 233px)"
                  },
                  on: { "row-dblclick": _vm.handleRowDBClick }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", "min-width": "50" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "welcomeContent",
                      label: "欢迎语",
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "name-wrap" }, [
                              _vm._v(
                                " " + _vm._s(scope.row.welcomeContent) + " "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "creatorName",
                      label: "创建人",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", "min-width": "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            true
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.handleEdit(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            true
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.delHandle(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            !true
                              ? _c(
                                  "span",
                                  { staticStyle: { "font-size": "12px" } },
                                  [_vm._v("生成中")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("WelcomeDia", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          diaTitle: this.diaTitle,
          editData: this.editData
        },
        on: { cancelHandle: _vm.cancelHandle, saveHandle: _vm.saveHandle }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }